import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';

const style = {
  margin: '10px'
};

export default class FilterControls extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      name: '',
      company: '',
      email: '',
      stage: '',
      sexo: ''
    };
  }
  render() {
    return (
      <form className='form form-inline' style={{ border: '1px solid black', margin: '10px' }}>
        <h2 style={{ margin: '10px' }}>Filtrar</h2>
        <input className='form-control' style={style} type='text' placeholder='Nombre' value={this.state.name} onChange={this.handleTextboxChange('name')}></input>
        <input className='form-control' style={style} type='text' placeholder='Empresa' value={this.state.company} onChange={this.handleTextboxChange('company')}></input>
        <input className='form-control' style={style} type='text' placeholder='Email' value={this.state.email} onChange={this.handleTextboxChange('email')}></input>
        <input className='form-control' style={style} type='text' placeholder='Consultor' value={this.state.consultor} onChange={this.handleTextboxChange('consultant')}></input>
        <select className='form-control' style={style} onChange={(e) => this.setState({ sex: e.target.value })}>
          <option value=''>Sexo</option>
          <option value='M'>Masculino</option>
          <option value='F'>Femenino</option>
        </select>
        <select className='form-control' style={style} onChange={(e) => this.setState({ stage: e.target.value })}>
          <option value=''>Estatus</option>
          <option value='0'>No Iniciado</option>
          <option value='1'>Cuestionario 1</option>
          <option value='2'>Cuestionario 2</option>
          <option value='3'>Completado</option>
        </select>
        <div>
          <button type='submit' style={style} className='btn btn-default' disabled={!this.valid()} onClick={this.handleSubmit}>Filtrar</button>
        </div>
      </form>
    );
  }
  handleTextboxChange(propName) {
    return (event) => {
      this.setState({ [propName]: event.target.value });
    }
  }
  handleSubmit(event) {
    event.preventDefault();
    this.props.onSubmit(this.state);
  }
  valid() {
    const formValidations = {
      name: R.either(validations.name, R.isEmpty),
      company: R.either(validations.company, R.isEmpty),
      email: R.either(validations.email, R.isEmpty),
    };

    return validations.validateObject(formValidations, this.state);
  }
}



// WEBPACK FOOTER //
// ./src/App/users/FilterControls.jsx